import { List } from 'immutable';
import { fundmetricRecordConstants } from '../constants';

export function fundMetric_records(state = {}, action) {
  switch (action.type) {
    case fundmetricRecordConstants.FUNDMETRIC_RECORD_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case fundmetricRecordConstants.FUNDMETRIC_RECORD_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case fundmetricRecordConstants.FUNDMETRIC_RECORD_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };
    case fundmetricRecordConstants.FUNDMETRIC_RECORD_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case fundmetricRecordConstants.FUNDMETRIC_RECORD_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case fundmetricRecordConstants.FUNDMETRIC_RECORD_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case fundmetricRecordConstants.FUNDMETRIC_RECORD_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case fundmetricRecordConstants.FUNDMETRIC_RECORD_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const fundMetricRecordIndex = state.items.findIndex(val => val.id == action.response.id);

      if (fundMetricRecordIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(fundMetricRecordIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case fundmetricRecordConstants.FUNDMETRIC_RECORD_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case fundmetricRecordConstants.FUNDMETRIC_RECORD_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case fundmetricRecordConstants.FUNDMETRIC_RECORD_DELETE_SUCCESS: {
      const { fundMetricRecordId } = action;

      if (!state.items) {
        return state;
      }

      const fundMetricRecordIndex = state.items.findIndex(val => val.id == fundMetricRecordId);

      if (fundMetricRecordIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(fundMetricRecordIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case fundmetricRecordConstants.FUNDMETRIC_RECORD_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case fundmetricRecordConstants.FUNDMETRIC_RECORD_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
